import { useEffect, useState } from 'react';
import store from 'root/admin/store';

const { PER_PAGE } = store.ui;

export const useGetRecords = ({ model, options, tabName, reload, filter }) => {
	const [records, setRecords] = useState();
	useEffect(() => {
		tabName && store.ui.setPage(tabName);
		let loading = true;
		getRecords()
			.then(res => {
				loading && setRecords(res);
			})
			.catch(err => {
				console.error('Fetch error', err);
			});
		return () => (loading = false);
	}, [filter]);

	const getRecords = async () => {
		return await store.model[model]
			.find({ ...options, ...filter, limit: filter && filter.limit ? filter.limit : PER_PAGE })
			.then(res => res)
			.catch(err => console.error(err));
	};
	return records;
};

export const useGetRecord = ({ model, id, options, tabName }) => {
	const [record, setRecord] = useState();
	console.log('page', tabName);
	useEffect(() => {
		tabName && store.ui.setPage(tabName);
		let loading = true;
		getRecord()
			.then(res => {
				loading && setRecord(res);
			})
			.catch(err => {
				console.error('Fetch error', err);
			});
		return () => (loading = false);
	}, []);

	const getRecord = async () => {
		let record;
		if (isNaN(id)) {
			record = new store.model[model]();
		} else {
			console.log('options', options);
			record = await store.model[model].findById(id, {
				...options,
			});
		}

		return record;
	};

	return record;
};
